






























































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as data from "@/_store/data.module";
import * as temp from "../../_store/temp.module";
import AllievoCreate from "@/components/Create/AllievoCreate.vue";

interface Company {
    id: number;
    ragioneSociale: string;
    partitaIva: string;
    comune: string;
    provincia: string;
}

interface Tutor {
    id: number;
    nome: string;
    cognome: string;
    email: string;
    specializzazione: string;
    nomeCompleto: string;
}

@Component({
    components: {
        AllievoCreate,
        DetailsDialog: () => import("../Dialogs/DetailsDialog.vue")
    }
})
export default class AbbinamentoAlternanzaCreate extends Vue {
    @Prop() info!: any;
    // Stepper state
    private currentStep: number = 1;
    private saving: boolean = false;

    // Selected items
    private utentiSelezionati: any[] = [];
    private disponibilitaSelezionate: any[] = [];
    private tutorSelezionati: any[] = [];

    // Search fields
    private studentSearch: string = "";
    private disponibilitaSearch: string = "";
    private tutorSearch: string = "";

    // Data arrays
    private studenti: any[] = [];
    private disponibilita: any[] = [];
    private tutors: any[] = [];

    // Loading states
    private loadingStudents: boolean = false;
    private loadingCompanies: boolean = false;
    private loadingTutors: boolean = false;

    // Table headers
    private studentHeaders = [
        { text: 'Nome', value: 'nomeUtente', sortable: true },
        { text: 'Cognome', value: 'cognomeUtente', sortable: true },
        { text: 'Codice Fiscale', value: 'cod', sortable: true },
        { text: 'Classe', value: 'classe', sortable: true }
    ];

    private disponibilitaHeaders = [
        { text: "Azienda", value: "denominazioneAzienda" },
        { text: "Luogo Svolgimento", value: "comuneTirocinio" },
        { text: "Nome Tirocinante Indicato", value: "nomeTirocinante" },
        { text: "Cognome Tirocinante Indicato", value: "cognomeTirocinante" },
        { text: "Dettagli Disponibilità", value: "details" }
    ];

    private tutorHeaders = [ 
        { text: "Tutor", value: "tutorFormativo" },
        { text: "Residenza", value: "comuneUtente" },
        { text: "Dettagli Tutor", value: "details" }
    ];

    constructor() {
        super();
    }

    get selectedStudent() {
        return this.utentiSelezionati && this.utentiSelezionati.length > 0 ? this.utentiSelezionati[0] : null;
    }

    get selectedDisponibilita() {
        return this.disponibilitaSelezionate && this.disponibilitaSelezionate.length > 0 ? this.disponibilitaSelezionate[0] : null;
    }

    get selectedTutor() {
        return this.tutors && this.tutors.length > 0 ? this.tutors[0] : null;
    }

    // Stepper navigation
    nextStep() {
        if (this.currentStep < 4) {
            this.currentStep++;

            if (this.currentStep === 2) {
                this.loadDisponibilita();
            } else if (this.currentStep === 3) {
                this.loadTutors();
            }
        }
    }

    prevStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    async loadStudents() {
        this.loadingStudents = true;
        try {
            var instituteInfo = user.readInstituteInfo(this["$store"]);
            var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);

            var payload = {
                idIstituto: instituteInfo.id,
                idAnnoScolastico: idAnnoScolastico,
                tipoAttivita: 'alternanza'
            };

            data.dispatchAllieviIscrittiTipoAttivita(this["$store"], payload)
                .then((response) => {
                    this.studenti = response.filter((student: any) => student.idStatoDoc === 2);
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                    } else {
                        bus.$emit(
                            "errorOperation",
                            "Errore nella richiesta degli allievi"
                        );
                    }
                });
        } catch (error) {
            console.error("Errore caricamento studenti:", error);
            bus.$emit("errorOperation", "Errore nel caricamento degli allievi");
        } finally {
            this.loadingStudents = false;
        }
    }

    async loadDisponibilita() {
        this.loadingCompanies = true;
        try {
            var payload = {
                idIscrizioneAllievo: this.selectedStudent.idIscrizioneAllievo
            };
            data
                .dispatchRichiesteAttivita(this["$store"], payload)
                .then(result => {
                    this.disponibilita = result;
                })
                .catch(error => {
                    if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                    } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    }
                });
        } catch (error) {
            console.error("Errore caricamento aziende:", error);
            bus.$emit("errorOperation", "Errore nel caricamento delle aziende");
        } finally {
            this.loadingCompanies = false;
        }
    }

    async loadTutors() {
        this.loadingTutors = true;
        try {
            var instituteInfo = user.readInstituteInfo(this["$store"]);
            var payload = {
                idIstituto: instituteInfo.id
            };
            data
                .dispatchTutorFormativi(this["$store"], payload)
                .then(result => {
                    this.tutors = result;
                })
                .catch(error => {
                    if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                    } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    }
                });
        } catch (error) {
            console.error("Errore caricamento tutor:", error);
            bus.$emit("errorOperation", "Errore nel caricamento dei tutor");
        } finally {
            this.loadingTutors = false;
        }
    }

    // Search methods (debounced)
    searchStudents() {
        // Implement debounced search if needed
    }

    searchCompanies() {
        // Implement debounced search if needed
    }

    searchTutors() {
        // Implement debounced search if needed
    }

    // Main actions
    async save() {
        if (!this.selectedStudent || !this.selectedDisponibilita || !this.selectedTutor) {
            bus.$emit("errorOperation", "Selezionare tutti gli elementi richiesti");
            return;
        }

        this.saving = true;
        try {
            const payload = {
                idAllievo: this.selectedStudent.idUtente,
                idIstitutoAnnoScolastico: this.selectedStudent.idIstitutoAnnoScolastico,
                idInformazioneAlternanza: this.selectedDisponibilita.idRichiesta,
                idTutorFormativo: this.selectedTutor.idUtente
            }

            await data.dispatchCreateAbbinamentoAlternanza(this["$store"], payload)
            .then(() => {
                bus.$emit("refreshAlternanzaAbbinamenti");
                bus.$emit("successfullOperation", "Abbinamento creato con successo");
                this.close();
            })
            .catch((error) => {
                console.error("Errore creazione abbinamento:", error);
                if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server' || "Errore nella creazione dell'abbinamento");
                }
            });

        } catch (error: any) {
            console.error("Errore creazione abbinamento:", error);
            if (error.response.status === 403) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
            } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server' || "Errore nella creazione dell'abbinamento");
            }
        } finally {
            this.saving = false;
        }
    }

    close() {
        this.reset();

        bus.$emit("closeCreateDialog");
    }

    reset() {
        this.currentStep = 1;
        this.utentiSelezionati = [];
        this.disponibilitaSelezionate = [];
        this.tutorSelezionati = [];
        this.studentSearch = "";
        this.disponibilitaSearch = "";
        this.tutorSearch = "";
    }

    async created() {
        await this.loadStudents();
    }
}
